// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2971e592","455":"31b309ea"}[chunkId] + ".chunk.js";
};